import React from "react"
import PropTypes from "prop-types"
import Layout from "../components/Layout"
import createCanonicalUrl from "../utils/createCanonicalUrl"
import TitleAndMetaTags from "../components/TitleAndMetaTags"
import { withStyles } from "@material-ui/core/styles"

import PublicationsPage from "../components/Publications"

const styles = {
  root: {
    width: "100%",
  },
}

const Publications = ({ location, classes }) => (
  <Layout location={location}>
    <TitleAndMetaTags
      title="Publications &ndash; DB System NUS"
      canonicalUrl={createCanonicalUrl("/publications")}
    />
    <div className={classes.root}>
      <PublicationsPage />
    </div>
  </Layout>
)

Publications.propTypes = {
  //data: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  classes: PropTypes.object.isRequired,
}

export default withStyles(styles)(Publications)
